/* src/app/footer/footer.component.scss */
.footer {
  background-color: #F2F2F2;
  width: 100%;
  color: #242424;
}
.legal-toggle {
  position: relative;
  border: solid 1px #757575;
  border-right: none;
  border-left: none;
  height: 51px;
  line-height: 51px;
  padding-left: 16px;
}
.show-legal-indicator {
  font-size: 16px;
  font-weight: 700;
}
.show-legal-indicator:not(.active)::after {
  font-family: "upsicons", fantasy !important;
  content: "\e65b" !important;
  color: black;
  position: absolute;
  right: 16px;
}
.show-legal-indicator.active::after {
  font-family: "upsicons", fantasy !important;
  content: "\e653" !important;
  color: black;
  position: absolute;
  right: 16px;
}
.hide-legal {
  display: none !important;
  height: 56px;
}
.legal-info {
  padding-left: 36px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  border-bottom: solid 1px #757575;
  height: 139px;
}
.legal-info div a {
  color: #242424 !important;
}
.copyright-info {
  height: 56px;
  font-size: 12px;
  color: black;
  padding-left: 22px;
  padding-right: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
@media (min-width: 768px) {
  .show-legal-indicator:not(.active)::after {
    right: 22px;
  }
  .show-legal-indicator.active::after {
    right: 22px;
  }
  .copyright-info {
    padding-right: 22px;
  }
}
@media (min-width: 992px) {
  .legal-toggle {
    display: none !important;
  }
  .hide-legal {
    display: block !important;
  }
  .footer-info {
    height: 56px;
    overflow-y: hidden;
    padding-top: 20px;
    font-size: 12px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  }
  .legal-info {
    display: flex !important;
    flex-direction: row;
    margin-right: 22px;
  }
  .legal-info div a {
    color: black !important;
  }
  .legal-info div:nth-of-type(1) a {
    margin-right: 14px;
    padding-right: 6px;
    border-right: solid 1px #757575;
  }
  .copyright-info {
    display: block;
    padding: auto;
  }
}
@media (min-width: 1880px) {
  .legal-info {
    margin-right: 152px;
  }
  .copyright-info {
    padding-left: 152px;
  }
}
/*# sourceMappingURL=footer.component.css.map */
